<c-card *transloco="let t" class="main-locations-card locations-theme">
  <c-card-body class="px-2">


<div class="row g-3 locations-toolbar">
  <div class="col-12">
    <div class="locations-toolbar__main">
      <div>
        <h1 class="locations-page-title mb-1">{{ t('Worker Locations') }}</h1>
        <p class="locations-page-copy mb-0">{{ t('This map shows the location of all workers who have an active session.') }}</p>
      </div>
      <div class="locations-toolbar__meta">
          <!-- <button type="button" class="btn btn-light" (click)="toggleWorkers()"  *ngIf="okService.isGeotab()">
            <span *ngIf="settings.workers"><i class="fa-solid fa-eye-slash"></i> {{ t('Hide Workers') }}</span>
            <span *ngIf="!settings.workers"><i class="fa-solid fa-eye"></i> {{ t('Show Workers') }}</span>
          </button> -->
          <!-- <button type="button" class="btn btn-light" (click)="toggleVehicles()"  *ngIf="okService.isGeotab()">
            <span *ngIf="settings.vehicles"><i class="fa-solid fa-eye-slash"></i> {{ t('Hide Vehicles') }}</span>
            <span *ngIf="!settings.vehicles"><i class="fa-solid fa-eye"></i> {{ t('Show Vehicles') }}</span>
          </button> -->
          <c-dropdown class="locations-toolbar__dropdown">
            <button cButton cDropdownToggle type="button" class="btn locations-btn locations-btn--secondary">
              {{ t('Map View') }}
              <span class="locations-dropdown-value" *ngIf="style=='streets-v12'">{{ t('Streets') }}</span>
              <span class="locations-dropdown-value" *ngIf="style=='satellite-streets-v12'">{{ t('Satellite') }}</span>
              <span class="locations-dropdown-value" *ngIf="style=='outdoors-v12'">{{ t('Outdoors') }}</span>
            </button>
            <ul cDropdownMenu>
              <li><button cDropdownItem type="button" (click)="changeStyle('streets-v12')">{{ t('Streets') }}</button></li>
              <li><button cDropdownItem type="button" (click)="changeStyle('satellite-streets-v12')">{{ t('Satellite') }}</button></li>
              <li><button cDropdownItem type="button" (click)="changeStyle('outdoors-v12')">{{ t('Outdoors') }}</button></li>
            </ul>
          </c-dropdown>
          <button type="button"
                  class="btn locations-btn locations-btn--toggle"
                  [ngClass]="{'locations-btn--active': show_names=='show'}"
                  (click)="toggleShowNames()">
            <span *ngIf="show_names!='show'">{{ t('Show Names') }}</span>
            <span *ngIf="show_names=='show'">{{ t('Hide Names') }}</span>
          </button>
          <button type="button" class="btn locations-btn locations-btn--secondary" (click)="refreshLocations()">
            {{ t('Refresh') }} <countdown #cd [config]="config"></countdown>
          </button>
          <button type="button"
                  class="btn locations-btn locations-btn--toggle"
                  [ngClass]="{'locations-btn--active': view_color == 'group'}"
                  (click)="toggleViewColor()"
                  *ngIf="okService.groups && okService.groups.length> 0 && okService.hasFeature('groups') && workers && workers.length > 0">
            <span *ngIf="view_color == 'status'">{{ t('View by Group') }}</span>
            <span *ngIf="view_color == 'group'">{{ t('View by Status') }}</span>
          </button>
      </div>
    </div>
  </div>
</div>


<div class="row map-row" >
  <div class="col-12 col-lg-8 map-column" >
      <div id="shift_map"></div>
  </div>
  <div class="col-12 col-lg-4 sidebar-column">

    <!-- ── Sidebar tab bar (data-driven — add to tabConfig to grow) ── -->
    <ul class="nav nav-tabs sidebar-tabs locations-sidebar-tabs" *ngIf="tabConfig.length > 1">
      <li class="nav-item" *ngFor="let tab of tabConfig">
        <button class="nav-link"
                [class.active]="sidebarTab === tab.id"
                (click)="selectSidebarTab(tab.id)">
          {{ t(tab.label) }}
          <span class="badge locations-badge locations-tab-badge">{{ getTabCount(tab.id) }}</span>
        </button>
      </li>
    </ul>

    <!-- ── Tab panels ── -->
    <div class="tab-panel">

      <!-- Workers tab -->
      <ng-container *ngIf="sidebarTab === 'workers'">
        <div class="locations-panel mb-3">
          <div class="locations-panel__header locations-panel__header--clickable" id="filterHeader" (click)="toggleFilter()">
            <span>{{ t('Filter Workers') }}</span>
            <span class="locations-badge locations-badge--muted">{{ show_filter ? t('On') : t('Off') }}</span>
          </div>
          <div class="locations-panel__body" id="filterBody" [hidden]="!show_filter">
            <form cForm class="locations-filter-grid">
              <div class="row g-3">
                <div class="col-12">
                  <label for="search" class="form-label">{{ t('Search') }}</label>
                  <input cFormControl class="form-control" id="search" name="search" [placeholder]="t('Search')" [(ngModel)]="filter.search"/>
                </div>
                <div class="col-12">
                  <label for="form_monitors" class="form-label">{{ t('Shown Workers') }}</label>
                  <select class="form-select" id="form_monitors" name="monitors" cSelect [(ngModel)]="filter.monitor">
                    <option value="all">{{ t('All Workers') }}</option>
                    <option value="mine">{{ t('My Monitored') }}</option>
                  </select>
                </div>
                <div class="col-12" *ngIf="groups_array && groups_array.length > 0">
                  <label for="form_group" class="form-label">{{ t('Worker Group') }}</label>
                  <ng-select
                    id="form_group"
                    [items]="groups_array"
                    class="w-100"
                    name="group"
                    [(ngModel)]="filter.group"
                    bindLabel="name"
                    bindValue="id">
                  </ng-select>
                </div>
              </div>
              <div class="locations-filter-actions">
                <button cButton class="btn locations-btn locations-btn--primary" type="submit" (click)="updateFilter()" [disabled]="loading">{{ t('Search') }}</button>
                <button cButton class="btn locations-btn locations-btn--secondary" type="submit" (click)="clearFilter()" [disabled]="loading">{{ t('Reset filter') }}</button>
              </div>
            </form>
          </div>
        </div>

        <div class="alert alert-warning mb-3" role="alert" *ngIf="workers && workers.length === 0">
          {{ t("We don't currently have any locations for any workers on shift") }}
        </div>

        <div class="workers-list locations-scroll-area">
          <ng-container *ngIf="view_color == 'group'">
            <ng-container *ngFor="let item of groups | keyvalue">
              <div class="card locations-card mb-2" *ngIf="$any(item.value).workers.length > 0" [style.border-left]="'4px solid ' + $any(item.value).color">
                <div class="card-header locations-card__header locations-card__header--clickable" (click)="toggleGroup($any(item.value).name)">
                  <div class="locations-card__title d-flex align-items-center gap-2 locations-min-width-0">
                    <span class="badge text-white" [style.background-color]="$any(item.value).color">&nbsp;&nbsp;</span>
                    <strong class="text-truncate">{{$any(item.value).name}}</strong>
                  </div>
                  <div class="locations-card__actions">
                    <button type="button" class="btn locations-btn locations-btn--alert locations-btn--sm" *ngIf="groupHasAlert($any(item.value).workers) && !this.views[$any(item.value).name]">
                      {{ t('View Alert') }}
                    </button>
                    <span class="locations-count">#{{$any(item.value).workers.length}}</span>
                  </div>
                </div>
                <table class="table table-striped mb-0" *ngIf="this.views[$any(item.value).name]">
                  <tbody>
                    <ng-container *ngFor="let driver of $any(item.value).workers">
                      <tr [style.border-left]="'4px solid ' + getStatusBadge(driver.status).color">
                        <td class="align-middle">
                          <span class="badge text-white" [ngClass]="getStatusBadge(driver.status).class">{{ t(getStatusBadge(driver.status).text) }}</span>
                        </td>
                        <td class="align-middle"><strong>{{ driver.name }}</strong></td>
                        <td class="align-middle text-end">
                          <button type="button"
                                  class="btn locations-btn locations-btn--sm me-1"
                                  [ngClass]="driver.alert ? 'locations-btn--alert' : 'locations-btn--secondary'"
                                  (click)="toggleWorkerDetails(driver.num)">
                            {{ driver.alert ? t('View Alert') : t('Details') }}
                          </button>
                          <ng-container *ngIf="driver.loc_lat != 0">
                            <button type="button" class="btn locations-btn locations-btn--primary locations-btn--sm" (click)="goToLocation(driver)">
                              {{ t('View') }}
                            </button>
                          </ng-container>
                          <ng-container *ngIf="driver.loc_lat == 0">
                            <span class="locations-badge locations-badge--muted">{{ t('No Location') }}</span>
                          </ng-container>
                        </td>
                      </tr>
                      <tr *ngIf="this.views['worker_' + driver.num]">
                        <td colspan="4" style="padding: 1rem;">
                          <div class="locations-detail-block">
                          <div class="row">
                            <div class="col-md-6">
                              <p class="mb-2" *ngIf="driver.email"><strong>{{ t('Email') }}: </strong> <a [href]="'mailto:' + driver.email">{{ driver.email }}</a></p>
                              <p class="mb-2" *ngIf="driver.phone"><strong>{{ t('Phone') }}: </strong> <a [href]="'tel:' + driver.phone">{{ driver.phone }}</a></p>
                            </div>
                            <div class="col-md-6">
                              <p class="mb-2" *ngIf="driver.group_name"><strong>{{ t('Group') }}: </strong> {{ driver.group_name }}</p>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-12">
                              <button type="button" class="btn locations-btn locations-btn--secondary locations-btn--sm" routerLink="/mgmt/worker/{{driver.worker_id}}" routerLinkActive="active">
                                {{ t('Edit') }}
                              </button>
                            </div>
                          </div>
                          <div *ngIf="driver.alert" class="locations-alert-block">
                            <div class="mb-3">
                              <h3>{{ t('Alert') }}: {{ driver.alert.title }}</h3>
                              <p class="mb-2">{{ t('Alert Time') }}: {{ driver.alert.created }}</p>
                            </div>
                            <div class="row">
                              <div class="col-12">
                                <button class="btn locations-btn locations-btn--alert locations-btn--sm" type="button" routerLink="/reports/alert/{{driver.alert.id}}">
                                  {{ t('View Alert') }}
                                </button>
                              </div>
                            </div>
                          </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="view_color == 'status'">
            <div class="card locations-card mb-2" *ngFor="let driver of workers" [style.border-left]="'4px solid ' + getStatusBadge(driver.status).color">
              <div class="card-header locations-card__header">
                <div class="d-flex align-items-center gap-2 locations-card__title">
                  <span class="badge text-white me-2" [ngClass]="getStatusBadge(driver.status).class">{{ t(getStatusBadge(driver.status).text) }}</span>
                  <strong>{{ driver.name }}</strong>
                </div>
                <div class="locations-card__actions">
                  <button type="button"
                          class="btn locations-btn locations-btn--sm"
                          [ngClass]="driver.alert ? 'locations-btn--alert' : 'locations-btn--secondary'"
                          (click)="toggleWorkerDetails(driver.num)">
                    {{ driver.alert ? t('View Alert') : t('Details') }}
                  </button>
                  <ng-container *ngIf="driver.loc_lat != null && driver.loc_lat != 0">
                    <button type="button" class="btn locations-btn locations-btn--primary locations-btn--sm" (click)="goToLocation(driver)">
                      {{ t('View') }}
                    </button>
                  </ng-container>
                  <ng-container *ngIf="driver.loc_lat == 0">
                    <span class="locations-badge locations-badge--muted">{{ t('No Location') }}</span>
                  </ng-container>
                </div>
              </div>
              <div class="locations-detail-block" *ngIf="this.views['worker_' + driver.num]">
                <div class="row">
                  <div class="col-md-6">
                    <p class="mb-2" *ngIf="driver.email"><strong>{{ t('Email') }}: </strong> <a [href]="'mailto:' + driver.email">{{ driver.email }}</a></p>
                    <p class="mb-2" *ngIf="driver.phone"><strong>{{ t('Phone') }}: </strong> <a [href]="'tel:' + driver.phone">{{ driver.phone }}</a></p>
                  </div>
                  <div class="col-md-6">
                    <p class="mb-2" *ngIf="driver.group_name"><strong>{{ t('Group') }}: </strong> {{ driver.group_name }}</p>
                    <p class="mb-2"><strong>{{ t('Status') }}: </strong>
                      <span class="badge text-white" [ngClass]="getStatusBadge(driver.status).class">{{ t(getStatusBadge(driver.status).text) }}</span>
                    </p>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12">
                    <button type="button" class="btn locations-btn locations-btn--secondary locations-btn--sm" routerLink="/mgmt/worker/{{driver.worker_id}}" routerLinkActive="active">
                      {{ t('Edit') }}
                    </button>
                  </div>
                </div>
                <div *ngIf="driver.alert" class="locations-alert-block">
                  <div class="mb-3">
                    <h3>{{ t('Alert') }}: {{ driver.alert.title }}</h3>
                    <p class="mb-2">{{ t('Alert Time') }}: {{ driver.alert.created }}</p>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <button class="btn locations-btn locations-btn--alert locations-btn--sm" type="button" routerLink="/reports/alert/{{driver.alert.id}}">
                        {{ t('View Alert') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div><!-- /.workers-list -->
      </ng-container>

      <!-- Offenders tab (feature-flagged: features.offenders) -->
      <ng-container *ngIf="sidebarTab === 'offenders' && okService.hasFeature('offenders', false) && canViewOffendersTab()">
        <app-offender-list
          [items]="overlayLayers['offenders'].data"
          [isVisible]="overlayLayers['offenders'].visible"
          (flyTo)="flyToOffenderItem($event)"
          (toggleLayer)="onToggleLayer('offenders')">
        </app-offender-list>
      </ng-container>

      <!-- Threats tab (threat zones: weather, Factal, custom) -->
      <ng-container *ngIf="sidebarTab === 'threats' && okService.hasFeature('threat_zones', false)">
        <app-weather-alerts
          [items]="overlayLayers['threats'].data"
          [loading]="weatherLoading"
          [isVisible]="overlayLayers['threats'].visible"
          [defaultCountry]="''"
          [defaultProximity]="'500'"
          (flyTo)="flyToThreatItem($event)"
          (toggleLayer)="onToggleLayer('threats')"
          (refresh)="loadWeatherAlerts()"
          (filtersChanged)="onThreatFiltersChanged($event)"
          (listFiltersChanged)="onThreatListFiltersChanged($event)">
        </app-weather-alerts>
      </ng-container>

      <!-- Future overlay tabs: copy the block above, change the id, add the new component -->

    </div><!-- /.tab-panel -->

  </div>
</div>


</c-card-body>
</c-card>
